"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _backdrop = _interopRequireDefault(require("@gravity/backdrop"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _jsonMetadata = _interopRequireDefault(require("@gravity/json-metadata"));
var _price = _interopRequireDefault(require("@gravity/price"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _CheckResaleAvailability = _interopRequireDefault(require("./CheckResaleAvailability"));
var _DateLabel = _interopRequireDefault(require("./DateLabel"));
var _MatchTeamDetail = _interopRequireDefault(require("./MatchTeamDetail"));
var _ProductActions = _interopRequireDefault(require("./ProductActions"));
var _ProductDate = _interopRequireDefault(require("./ProductDate"));
var _ProductDescription = _interopRequireDefault(require("./ProductDescription"));
var _ProductDescriptionIcon = _interopRequireDefault(require("./ProductDescriptionIcon"));
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _ProductImage = _interopRequireDefault(require("./ProductImage"));
var _ProductIndicator = _interopRequireDefault(require("./ProductIndicator"));
var _ProductTitle = require("./ProductTitle");
var _utils2 = require("./utils");
var _jsxFileName = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17,
  _templateObject18,
  _templateObject19,
  _templateObject20,
  _templateObject21,
  _templateObject22,
  _templateObject23,
  _templateObject24,
  _templateObject25,
  _templateObject26,
  _templateObject27,
  _templateObject28,
  _templateObject29,
  _templateObject30,
  _this = void 0,
  _templateObject31,
  _templateObject32,
  _templateObject33;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_xmzdhde1r() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine.js";
  var hash = "6f16862344bf6965cbb3f39397b51ca700ae2231";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine.js",
    statementMap: {
      "0": {
        start: {
          line: 45,
          column: 35
        },
        end: {
          line: 45,
          column: 57
        }
      },
      "1": {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 112,
          column: 1
        }
      },
      "2": {
        start: {
          line: 49,
          column: 24
        },
        end: {
          line: 49,
          column: 76
        }
      },
      "3": {
        start: {
          line: 66,
          column: 32
        },
        end: {
          line: 66,
          column: 56
        }
      },
      "4": {
        start: {
          line: 71,
          column: 41
        },
        end: {
          line: 71,
          column: 74
        }
      },
      "5": {
        start: {
          line: 75,
          column: 32
        },
        end: {
          line: 75,
          column: 56
        }
      },
      "6": {
        start: {
          line: 114,
          column: 28
        },
        end: {
          line: 174,
          column: 1
        }
      },
      "7": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 95
        }
      },
      "8": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      "9": {
        start: {
          line: 175,
          column: 25
        },
        end: {
          line: 187,
          column: 1
        }
      },
      "10": {
        start: {
          line: 188,
          column: 18
        },
        end: {
          line: 192,
          column: 1
        }
      },
      "11": {
        start: {
          line: 194,
          column: 21
        },
        end: {
          line: 200,
          column: 1
        }
      },
      "12": {
        start: {
          line: 202,
          column: 23
        },
        end: {
          line: 208,
          column: 1
        }
      },
      "13": {
        start: {
          line: 210,
          column: 19
        },
        end: {
          line: 227,
          column: 1
        }
      },
      "14": {
        start: {
          line: 229,
          column: 28
        },
        end: {
          line: 235,
          column: 1
        }
      },
      "15": {
        start: {
          line: 236,
          column: 21
        },
        end: {
          line: 260,
          column: 1
        }
      },
      "16": {
        start: {
          line: 242,
          column: 24
        },
        end: {
          line: 242,
          column: 42
        }
      },
      "17": {
        start: {
          line: 244,
          column: 26
        },
        end: {
          line: 244,
          column: 42
        }
      },
      "18": {
        start: {
          line: 252,
          column: 24
        },
        end: {
          line: 252,
          column: 40
        }
      },
      "19": {
        start: {
          line: 262,
          column: 27
        },
        end: {
          line: 285,
          column: 2
        }
      },
      "20": {
        start: {
          line: 267,
          column: 66
        },
        end: {
          line: 267,
          column: 77
        }
      },
      "21": {
        start: {
          line: 280,
          column: 67
        },
        end: {
          line: 280,
          column: 78
        }
      },
      "22": {
        start: {
          line: 287,
          column: 21
        },
        end: {
          line: 299,
          column: 2
        }
      },
      "23": {
        start: {
          line: 301,
          column: 20
        },
        end: {
          line: 325,
          column: 2
        }
      },
      "24": {
        start: {
          line: 304,
          column: 22
        },
        end: {
          line: 304,
          column: 33
        }
      },
      "25": {
        start: {
          line: 317,
          column: 24
        },
        end: {
          line: 317,
          column: 35
        }
      },
      "26": {
        start: {
          line: 327,
          column: 27
        },
        end: {
          line: 337,
          column: 1
        }
      },
      "27": {
        start: {
          line: 338,
          column: 33
        },
        end: {
          line: 342,
          column: 1
        }
      },
      "28": {
        start: {
          line: 344,
          column: 29
        },
        end: {
          line: 352,
          column: 1
        }
      },
      "29": {
        start: {
          line: 354,
          column: 34
        },
        end: {
          line: 362,
          column: 1
        }
      },
      "30": {
        start: {
          line: 364,
          column: 26
        },
        end: {
          line: 385,
          column: 1
        }
      },
      "31": {
        start: {
          line: 387,
          column: 23
        },
        end: {
          line: 426,
          column: 1
        }
      },
      "32": {
        start: {
          line: 395,
          column: 26
        },
        end: {
          line: 395,
          column: 84
        }
      },
      "33": {
        start: {
          line: 396,
          column: 19
        },
        end: {
          line: 396,
          column: 35
        }
      },
      "34": {
        start: {
          line: 398,
          column: 2
        },
        end: {
          line: 425,
          column: 4
        }
      },
      "35": {
        start: {
          line: 428,
          column: 0
        },
        end: {
          line: 437,
          column: 2
        }
      },
      "36": {
        start: {
          line: 439,
          column: 0
        },
        end: {
          line: 444,
          column: 2
        }
      },
      "37": {
        start: {
          line: 446,
          column: 36
        },
        end: {
          line: 452,
          column: 2
        }
      },
      "38": {
        start: {
          line: 454,
          column: 21
        },
        end: {
          line: 487,
          column: 1
        }
      },
      "39": {
        start: {
          line: 456,
          column: 4
        },
        end: {
          line: 485,
          column: 19
        }
      },
      "40": {
        start: {
          line: 489,
          column: 0
        },
        end: {
          line: 495,
          column: 2
        }
      },
      "41": {
        start: {
          line: 497,
          column: 0
        },
        end: {
          line: 500,
          column: 2
        }
      },
      "42": {
        start: {
          line: 502,
          column: 20
        },
        end: {
          line: 529,
          column: 1
        }
      },
      "43": {
        start: {
          line: 505,
          column: 6
        },
        end: {
          line: 526,
          column: 27
        }
      },
      "44": {
        start: {
          line: 531,
          column: 0
        },
        end: {
          line: 544,
          column: 2
        }
      },
      "45": {
        start: {
          line: 546,
          column: 0
        },
        end: {
          line: 551,
          column: 2
        }
      },
      "46": {
        start: {
          line: 554,
          column: 20
        },
        end: {
          line: 620,
          column: 1
        }
      },
      "47": {
        start: {
          line: 568,
          column: 28
        },
        end: {
          line: 574,
          column: 12
        }
      },
      "48": {
        start: {
          line: 569,
          column: 10
        },
        end: {
          line: 571,
          column: 11
        }
      },
      "49": {
        start: {
          line: 570,
          column: 12
        },
        end: {
          line: 570,
          column: 30
        }
      },
      "50": {
        start: {
          line: 573,
          column: 10
        },
        end: {
          line: 573,
          column: 58
        }
      },
      "51": {
        start: {
          line: 576,
          column: 8
        },
        end: {
          line: 593,
          column: 9
        }
      },
      "52": {
        start: {
          line: 577,
          column: 10
        },
        end: {
          line: 592,
          column: 12
        }
      },
      "53": {
        start: {
          line: 596,
          column: 10
        },
        end: {
          line: 606,
          column: 25
        }
      },
      "54": {
        start: {
          line: 609,
          column: 8
        },
        end: {
          line: 611,
          column: 9
        }
      },
      "55": {
        start: {
          line: 610,
          column: 10
        },
        end: {
          line: 610,
          column: 47
        }
      },
      "56": {
        start: {
          line: 612,
          column: 8
        },
        end: {
          line: 616,
          column: 10
        }
      },
      "57": {
        start: {
          line: 622,
          column: 0
        },
        end: {
          line: 637,
          column: 2
        }
      },
      "58": {
        start: {
          line: 639,
          column: 0
        },
        end: {
          line: 651,
          column: 2
        }
      },
      "59": {
        start: {
          line: 653,
          column: 21
        },
        end: {
          line: 655,
          column: 1
        }
      },
      "60": {
        start: {
          line: 656,
          column: 23
        },
        end: {
          line: 659,
          column: 1
        }
      },
      "61": {
        start: {
          line: 661,
          column: 32
        },
        end: {
          line: 665,
          column: 1
        }
      },
      "62": {
        start: {
          line: 662,
          column: 2
        },
        end: {
          line: 662,
          column: 41
        }
      },
      "63": {
        start: {
          line: 662,
          column: 19
        },
        end: {
          line: 662,
          column: 41
        }
      },
      "64": {
        start: {
          line: 663,
          column: 2
        },
        end: {
          line: 663,
          column: 35
        }
      },
      "65": {
        start: {
          line: 663,
          column: 16
        },
        end: {
          line: 663,
          column: 35
        }
      },
      "66": {
        start: {
          line: 664,
          column: 2
        },
        end: {
          line: 664,
          column: 20
        }
      },
      "67": {
        start: {
          line: 667,
          column: 32
        },
        end: {
          line: 718,
          column: 1
        }
      },
      "68": {
        start: {
          line: 668,
          column: 30
        },
        end: {
          line: 668,
          column: 35
        }
      },
      "69": {
        start: {
          line: 669,
          column: 18
        },
        end: {
          line: 669,
          column: 22
        }
      },
      "70": {
        start: {
          line: 670,
          column: 22
        },
        end: {
          line: 670,
          column: 26
        }
      },
      "71": {
        start: {
          line: 671,
          column: 19
        },
        end: {
          line: 671,
          column: 23
        }
      },
      "72": {
        start: {
          line: 672,
          column: 21
        },
        end: {
          line: 672,
          column: 25
        }
      },
      "73": {
        start: {
          line: 673,
          column: 19
        },
        end: {
          line: 673,
          column: 21
        }
      },
      "74": {
        start: {
          line: 674,
          column: 23
        },
        end: {
          line: 674,
          column: 28
        }
      },
      "75": {
        start: {
          line: 675,
          column: 24
        },
        end: {
          line: 675,
          column: 29
        }
      },
      "76": {
        start: {
          line: 677,
          column: 2
        },
        end: {
          line: 707,
          column: 3
        }
      },
      "77": {
        start: {
          line: 678,
          column: 4
        },
        end: {
          line: 678,
          column: 33
        }
      },
      "78": {
        start: {
          line: 679,
          column: 4
        },
        end: {
          line: 685,
          column: 5
        }
      },
      "79": {
        start: {
          line: 680,
          column: 6
        },
        end: {
          line: 680,
          column: 29
        }
      },
      "80": {
        start: {
          line: 681,
          column: 6
        },
        end: {
          line: 681,
          column: 54
        }
      },
      "81": {
        start: {
          line: 682,
          column: 6
        },
        end: {
          line: 682,
          column: 89
        }
      },
      "82": {
        start: {
          line: 683,
          column: 6
        },
        end: {
          line: 683,
          column: 72
        }
      },
      "83": {
        start: {
          line: 684,
          column: 6
        },
        end: {
          line: 684,
          column: 86
        }
      },
      "84": {
        start: {
          line: 686,
          column: 4
        },
        end: {
          line: 706,
          column: 5
        }
      },
      "85": {
        start: {
          line: 687,
          column: 6
        },
        end: {
          line: 687,
          column: 29
        }
      },
      "86": {
        start: {
          line: 688,
          column: 6
        },
        end: {
          line: 690,
          column: 7
        }
      },
      "87": {
        start: {
          line: 689,
          column: 8
        },
        end: {
          line: 689,
          column: 39
        }
      },
      "88": {
        start: {
          line: 691,
          column: 6
        },
        end: {
          line: 693,
          column: 7
        }
      },
      "89": {
        start: {
          line: 692,
          column: 8
        },
        end: {
          line: 692,
          column: 33
        }
      },
      "90": {
        start: {
          line: 694,
          column: 6
        },
        end: {
          line: 696,
          column: 44
        }
      },
      "91": {
        start: {
          line: 697,
          column: 6
        },
        end: {
          line: 699,
          column: 80
        }
      },
      "92": {
        start: {
          line: 700,
          column: 6
        },
        end: {
          line: 702,
          column: 59
        }
      },
      "93": {
        start: {
          line: 703,
          column: 6
        },
        end: {
          line: 705,
          column: 72
        }
      },
      "94": {
        start: {
          line: 708,
          column: 2
        },
        end: {
          line: 717,
          column: 4
        }
      },
      "95": {
        start: {
          line: 721,
          column: 21
        },
        end: {
          line: 912,
          column: 1
        }
      },
      "96": {
        start: {
          line: 740,
          column: 8
        },
        end: {
          line: 740,
          column: 42
        }
      },
      "97": {
        start: {
          line: 741,
          column: 24
        },
        end: {
          line: 741,
          column: 96
        }
      },
      "98": {
        start: {
          line: 743,
          column: 24
        },
        end: {
          line: 743,
          column: 62
        }
      },
      "99": {
        start: {
          line: 744,
          column: 36
        },
        end: {
          line: 744,
          column: 64
        }
      },
      "100": {
        start: {
          line: 745,
          column: 26
        },
        end: {
          line: 745,
          column: 68
        }
      },
      "101": {
        start: {
          line: 746,
          column: 33
        },
        end: {
          line: 746,
          column: 58
        }
      },
      "102": {
        start: {
          line: 748,
          column: 47
        },
        end: {
          line: 752,
          column: 7
        }
      },
      "103": {
        start: {
          line: 753,
          column: 24
        },
        end: {
          line: 753,
          column: 80
        }
      },
      "104": {
        start: {
          line: 754,
          column: 28
        },
        end: {
          line: 754,
          column: 59
        }
      },
      "105": {
        start: {
          line: 754,
          column: 35
        },
        end: {
          line: 754,
          column: 56
        }
      },
      "106": {
        start: {
          line: 756,
          column: 29
        },
        end: {
          line: 778,
          column: 7
        }
      },
      "107": {
        start: {
          line: 757,
          column: 8
        },
        end: {
          line: 777,
          column: 28
        }
      },
      "108": {
        start: {
          line: 774,
          column: 51
        },
        end: {
          line: 774,
          column: 83
        }
      },
      "109": {
        start: {
          line: 780,
          column: 32
        },
        end: {
          line: 798,
          column: 7
        }
      },
      "110": {
        start: {
          line: 781,
          column: 8
        },
        end: {
          line: 797,
          column: 15
        }
      },
      "111": {
        start: {
          line: 800,
          column: 31
        },
        end: {
          line: 806,
          column: 7
        }
      },
      "112": {
        start: {
          line: 801,
          column: 8
        },
        end: {
          line: 805,
          column: 15
        }
      },
      "113": {
        start: {
          line: 808,
          column: 38
        },
        end: {
          line: 901,
          column: 7
        }
      },
      "114": {
        start: {
          line: 809,
          column: 32
        },
        end: {
          line: 809,
          column: 59
        }
      },
      "115": {
        start: {
          line: 810,
          column: 30
        },
        end: {
          line: 810,
          column: 43
        }
      },
      "116": {
        start: {
          line: 811,
          column: 26
        },
        end: {
          line: 811,
          column: 43
        }
      },
      "117": {
        start: {
          line: 812,
          column: 22
        },
        end: {
          line: 812,
          column: 86
        }
      },
      "118": {
        start: {
          line: 823,
          column: 12
        },
        end: {
          line: 823,
          column: 78
        }
      },
      "119": {
        start: {
          line: 826,
          column: 8
        },
        end: {
          line: 829,
          column: 9
        }
      },
      "120": {
        start: {
          line: 828,
          column: 10
        },
        end: {
          line: 828,
          column: 35
        }
      },
      "121": {
        start: {
          line: 831,
          column: 10
        },
        end: {
          line: 833,
          column: 12
        }
      },
      "122": {
        start: {
          line: 835,
          column: 8
        },
        end: {
          line: 870,
          column: 9
        }
      },
      "123": {
        start: {
          line: 836,
          column: 10
        },
        end: {
          line: 869,
          column: 12
        }
      },
      "124": {
        start: {
          line: 845,
          column: 18
        },
        end: {
          line: 849,
          column: 19
        }
      },
      "125": {
        start: {
          line: 871,
          column: 8
        },
        end: {
          line: 900,
          column: 10
        }
      },
      "126": {
        start: {
          line: 902,
          column: 6
        },
        end: {
          line: 909,
          column: 8
        }
      },
      "127": {
        start: {
          line: 914,
          column: 0
        },
        end: {
          line: 941,
          column: 2
        }
      },
      "128": {
        start: {
          line: 943,
          column: 0
        },
        end: {
          line: 960,
          column: 2
        }
      },
      "129": {
        start: {
          line: 965,
          column: 20
        },
        end: {
          line: 1077,
          column: 1
        }
      },
      "130": {
        start: {
          line: 982,
          column: 6
        },
        end: {
          line: 982,
          column: 11
        }
      },
      "131": {
        start: {
          line: 984,
          column: 37
        },
        end: {
          line: 984,
          column: 44
        }
      },
      "132": {
        start: {
          line: 987,
          column: 21
        },
        end: {
          line: 987,
          column: 55
        }
      },
      "133": {
        start: {
          line: 988,
          column: 4
        },
        end: {
          line: 988,
          column: 37
        }
      },
      "134": {
        start: {
          line: 989,
          column: 4
        },
        end: {
          line: 989,
          column: 52
        }
      },
      "135": {
        start: {
          line: 992,
          column: 24
        },
        end: {
          line: 998,
          column: 3
        }
      },
      "136": {
        start: {
          line: 1000,
          column: 22
        },
        end: {
          line: 1002,
          column: 3
        }
      },
      "137": {
        start: {
          line: 1003,
          column: 18
        },
        end: {
          line: 1003,
          column: 82
        }
      },
      "138": {
        start: {
          line: 1004,
          column: 18
        },
        end: {
          line: 1004,
          column: 73
        }
      },
      "139": {
        start: {
          line: 1005,
          column: 36
        },
        end: {
          line: 1005,
          column: 89
        }
      },
      "140": {
        start: {
          line: 1006,
          column: 29
        },
        end: {
          line: 1006,
          column: 91
        }
      },
      "141": {
        start: {
          line: 1007,
          column: 23
        },
        end: {
          line: 1012,
          column: 4
        }
      },
      "142": {
        start: {
          line: 1015,
          column: 4
        },
        end: {
          line: 1019,
          column: 25
        }
      },
      "143": {
        start: {
          line: 1022,
          column: 2
        },
        end: {
          line: 1076,
          column: 4
        }
      },
      "144": {
        start: {
          line: 1079,
          column: 0
        },
        end: {
          line: 1106,
          column: 2
        }
      },
      "145": {
        start: {
          line: 1108,
          column: 0
        },
        end: {
          line: 1127,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 49,
            column: 15
          },
          end: {
            line: 49,
            column: 16
          }
        },
        loc: {
          start: {
            line: 49,
            column: 24
          },
          end: {
            line: 49,
            column: 76
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 66,
            column: 17
          },
          end: {
            line: 66,
            column: 18
          }
        },
        loc: {
          start: {
            line: 66,
            column: 32
          },
          end: {
            line: 66,
            column: 56
          }
        },
        line: 66
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 26
          },
          end: {
            line: 71,
            column: 27
          }
        },
        loc: {
          start: {
            line: 71,
            column: 41
          },
          end: {
            line: 71,
            column: 74
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 75,
            column: 17
          },
          end: {
            line: 75,
            column: 18
          }
        },
        loc: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 56
          }
        },
        line: 75
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 116,
            column: 15
          },
          end: {
            line: 116,
            column: 16
          }
        },
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 95
          }
        },
        line: 117
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 9
          }
        },
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        line: 144
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 242,
            column: 15
          },
          end: {
            line: 242,
            column: 16
          }
        },
        loc: {
          start: {
            line: 242,
            column: 24
          },
          end: {
            line: 242,
            column: 42
          }
        },
        line: 242
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 244,
            column: 17
          },
          end: {
            line: 244,
            column: 18
          }
        },
        loc: {
          start: {
            line: 244,
            column: 26
          },
          end: {
            line: 244,
            column: 42
          }
        },
        line: 244
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 252,
            column: 15
          },
          end: {
            line: 252,
            column: 16
          }
        },
        loc: {
          start: {
            line: 252,
            column: 24
          },
          end: {
            line: 252,
            column: 40
          }
        },
        line: 252
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 267,
            column: 36
          },
          end: {
            line: 267,
            column: 37
          }
        },
        loc: {
          start: {
            line: 267,
            column: 66
          },
          end: {
            line: 267,
            column: 77
          }
        },
        line: 267
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 280,
            column: 36
          },
          end: {
            line: 280,
            column: 37
          }
        },
        loc: {
          start: {
            line: 280,
            column: 67
          },
          end: {
            line: 280,
            column: 78
          }
        },
        line: 280
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 304,
            column: 13
          },
          end: {
            line: 304,
            column: 14
          }
        },
        loc: {
          start: {
            line: 304,
            column: 22
          },
          end: {
            line: 304,
            column: 33
          }
        },
        line: 304
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 317,
            column: 15
          },
          end: {
            line: 317,
            column: 16
          }
        },
        loc: {
          start: {
            line: 317,
            column: 24
          },
          end: {
            line: 317,
            column: 35
          }
        },
        line: 317
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 387,
            column: 23
          },
          end: {
            line: 387,
            column: 24
          }
        },
        loc: {
          start: {
            line: 393,
            column: 6
          },
          end: {
            line: 426,
            column: 1
          }
        },
        line: 393
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 455,
            column: 19
          },
          end: {
            line: 455,
            column: 20
          }
        },
        loc: {
          start: {
            line: 456,
            column: 4
          },
          end: {
            line: 485,
            column: 19
          }
        },
        line: 456
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 504,
            column: 4
          },
          end: {
            line: 504,
            column: 5
          }
        },
        loc: {
          start: {
            line: 505,
            column: 6
          },
          end: {
            line: 526,
            column: 27
          }
        },
        line: 505
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 557,
            column: 6
          },
          end: {
            line: 557,
            column: 7
          }
        },
        loc: {
          start: {
            line: 567,
            column: 12
          },
          end: {
            line: 617,
            column: 7
          }
        },
        line: 567
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 568,
            column: 29
          },
          end: {
            line: 568,
            column: 30
          }
        },
        loc: {
          start: {
            line: 568,
            column: 35
          },
          end: {
            line: 574,
            column: 9
          }
        },
        line: 568
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 661,
            column: 32
          },
          end: {
            line: 661,
            column: 33
          }
        },
        loc: {
          start: {
            line: 661,
            column: 68
          },
          end: {
            line: 665,
            column: 1
          }
        },
        line: 661
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 667,
            column: 32
          },
          end: {
            line: 667,
            column: 33
          }
        },
        loc: {
          start: {
            line: 667,
            column: 79
          },
          end: {
            line: 718,
            column: 1
          }
        },
        line: 667
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 723,
            column: 4
          },
          end: {
            line: 723,
            column: 5
          }
        },
        loc: {
          start: {
            line: 738,
            column: 10
          },
          end: {
            line: 910,
            column: 5
          }
        },
        line: 738
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 754,
            column: 29
          },
          end: {
            line: 754,
            column: 30
          }
        },
        loc: {
          start: {
            line: 754,
            column: 35
          },
          end: {
            line: 754,
            column: 56
          }
        },
        line: 754
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 756,
            column: 29
          },
          end: {
            line: 756,
            column: 30
          }
        },
        loc: {
          start: {
            line: 757,
            column: 8
          },
          end: {
            line: 777,
            column: 28
          }
        },
        line: 757
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 774,
            column: 45
          },
          end: {
            line: 774,
            column: 46
          }
        },
        loc: {
          start: {
            line: 774,
            column: 51
          },
          end: {
            line: 774,
            column: 83
          }
        },
        line: 774
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 780,
            column: 32
          },
          end: {
            line: 780,
            column: 33
          }
        },
        loc: {
          start: {
            line: 781,
            column: 8
          },
          end: {
            line: 797,
            column: 15
          }
        },
        line: 781
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 800,
            column: 31
          },
          end: {
            line: 800,
            column: 32
          }
        },
        loc: {
          start: {
            line: 801,
            column: 8
          },
          end: {
            line: 805,
            column: 15
          }
        },
        line: 801
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 808,
            column: 38
          },
          end: {
            line: 808,
            column: 39
          }
        },
        loc: {
          start: {
            line: 808,
            column: 44
          },
          end: {
            line: 901,
            column: 7
          }
        },
        line: 808
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 844,
            column: 31
          },
          end: {
            line: 844,
            column: 32
          }
        },
        loc: {
          start: {
            line: 845,
            column: 18
          },
          end: {
            line: 849,
            column: 19
          }
        },
        line: 845
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 965,
            column: 20
          },
          end: {
            line: 965,
            column: 21
          }
        },
        loc: {
          start: {
            line: 965,
            column: 29
          },
          end: {
            line: 1077,
            column: 1
          }
        },
        line: 965
      },
      "29": {
        name: "decodeHtmlString",
        decl: {
          start: {
            line: 985,
            column: 11
          },
          end: {
            line: 985,
            column: 27
          }
        },
        loc: {
          start: {
            line: 985,
            column: 41
          },
          end: {
            line: 990,
            column: 3
          }
        },
        line: 985
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 66,
            column: 32
          },
          end: {
            line: 66,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 32
          },
          end: {
            line: 66,
            column: 46
          }
        }, {
          start: {
            line: 66,
            column: 50
          },
          end: {
            line: 66,
            column: 56
          }
        }],
        line: 66
      },
      "1": {
        loc: {
          start: {
            line: 71,
            column: 41
          },
          end: {
            line: 71,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 41
          },
          end: {
            line: 71,
            column: 61
          }
        }, {
          start: {
            line: 71,
            column: 65
          },
          end: {
            line: 71,
            column: 74
          }
        }],
        line: 71
      },
      "2": {
        loc: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 46
          }
        }, {
          start: {
            line: 75,
            column: 50
          },
          end: {
            line: 75,
            column: 56
          }
        }],
        line: 75
      },
      "3": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 144,
            column: 14
          }
        }, {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }],
        line: 144
      },
      "4": {
        loc: {
          start: {
            line: 267,
            column: 39
          },
          end: {
            line: 267,
            column: 59
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 267,
            column: 53
          },
          end: {
            line: 267,
            column: 59
          }
        }],
        line: 267
      },
      "5": {
        loc: {
          start: {
            line: 280,
            column: 39
          },
          end: {
            line: 280,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 280,
            column: 53
          },
          end: {
            line: 280,
            column: 60
          }
        }],
        line: 280
      },
      "6": {
        loc: {
          start: {
            line: 410,
            column: 9
          },
          end: {
            line: 410,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 410,
            column: 9
          },
          end: {
            line: 410,
            column: 24
          }
        }, {
          start: {
            line: 410,
            column: 28
          },
          end: {
            line: 410,
            column: 66
          }
        }],
        line: 410
      },
      "7": {
        loc: {
          start: {
            line: 414,
            column: 9
          },
          end: {
            line: 421,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 414,
            column: 9
          },
          end: {
            line: 414,
            column: 17
          }
        }, {
          start: {
            line: 415,
            column: 10
          },
          end: {
            line: 420,
            column: 16
          }
        }],
        line: 414
      },
      "8": {
        loc: {
          start: {
            line: 461,
            column: 9
          },
          end: {
            line: 461,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 461,
            column: 10
          },
          end: {
            line: 461,
            column: 27
          }
        }, {
          start: {
            line: 461,
            column: 31
          },
          end: {
            line: 461,
            column: 55
          }
        }, {
          start: {
            line: 461,
            column: 60
          },
          end: {
            line: 461,
            column: 92
          }
        }],
        line: 461
      },
      "9": {
        loc: {
          start: {
            line: 468,
            column: 9
          },
          end: {
            line: 473,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 468,
            column: 10
          },
          end: {
            line: 468,
            column: 27
          }
        }, {
          start: {
            line: 468,
            column: 31
          },
          end: {
            line: 468,
            column: 47
          }
        }, {
          start: {
            line: 469,
            column: 10
          },
          end: {
            line: 472,
            column: 40
          }
        }],
        line: 468
      },
      "10": {
        loc: {
          start: {
            line: 470,
            column: 46
          },
          end: {
            line: 470,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 470,
            column: 71
          },
          end: {
            line: 470,
            column: 85
          }
        }, {
          start: {
            line: 470,
            column: 88
          },
          end: {
            line: 470,
            column: 93
          }
        }],
        line: 470
      },
      "11": {
        loc: {
          start: {
            line: 471,
            column: 13
          },
          end: {
            line: 471,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 471,
            column: 13
          },
          end: {
            line: 471,
            column: 30
          }
        }, {
          start: {
            line: 471,
            column: 34
          },
          end: {
            line: 471,
            column: 50
          }
        }],
        line: 471
      },
      "12": {
        loc: {
          start: {
            line: 474,
            column: 9
          },
          end: {
            line: 478,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 474,
            column: 9
          },
          end: {
            line: 474,
            column: 31
          }
        }, {
          start: {
            line: 475,
            column: 10
          },
          end: {
            line: 477,
            column: 35
          }
        }],
        line: 474
      },
      "13": {
        loc: {
          start: {
            line: 484,
            column: 7
          },
          end: {
            line: 484,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 484,
            column: 7
          },
          end: {
            line: 484,
            column: 29
          }
        }, {
          start: {
            line: 484,
            column: 33
          },
          end: {
            line: 484,
            column: 93
          }
        }],
        line: 484
      },
      "14": {
        loc: {
          start: {
            line: 507,
            column: 11
          },
          end: {
            line: 507,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 507,
            column: 38
          },
          end: {
            line: 507,
            column: 44
          }
        }, {
          start: {
            line: 507,
            column: 47
          },
          end: {
            line: 507,
            column: 59
          }
        }],
        line: 507
      },
      "15": {
        loc: {
          start: {
            line: 509,
            column: 21
          },
          end: {
            line: 509,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 509,
            column: 46
          },
          end: {
            line: 509,
            column: 86
          }
        }, {
          start: {
            line: 509,
            column: 89
          },
          end: {
            line: 509,
            column: 98
          }
        }],
        line: 509
      },
      "16": {
        loc: {
          start: {
            line: 510,
            column: 9
          },
          end: {
            line: 525,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 511,
            column: 10
          },
          end: {
            line: 515,
            column: 12
          }
        }, {
          start: {
            line: 517,
            column: 10
          },
          end: {
            line: 524,
            column: 12
          }
        }],
        line: 510
      },
      "17": {
        loc: {
          start: {
            line: 569,
            column: 10
          },
          end: {
            line: 571,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 569,
            column: 10
          },
          end: {
            line: 571,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 569
      },
      "18": {
        loc: {
          start: {
            line: 573,
            column: 17
          },
          end: {
            line: 573,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 573,
            column: 35
          },
          end: {
            line: 573,
            column: 43
          }
        }, {
          start: {
            line: 573,
            column: 46
          },
          end: {
            line: 573,
            column: 57
          }
        }],
        line: 573
      },
      "19": {
        loc: {
          start: {
            line: 576,
            column: 8
          },
          end: {
            line: 593,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 576,
            column: 8
          },
          end: {
            line: 593,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 576
      },
      "20": {
        loc: {
          start: {
            line: 579,
            column: 28
          },
          end: {
            line: 579,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 579,
            column: 55
          },
          end: {
            line: 579,
            column: 61
          }
        }, {
          start: {
            line: 579,
            column: 64
          },
          end: {
            line: 579,
            column: 70
          }
        }],
        line: 579
      },
      "21": {
        loc: {
          start: {
            line: 580,
            column: 26
          },
          end: {
            line: 580,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 580,
            column: 53
          },
          end: {
            line: 580,
            column: 58
          }
        }, {
          start: {
            line: 580,
            column: 61
          },
          end: {
            line: 580,
            column: 67
          }
        }],
        line: 580
      },
      "22": {
        loc: {
          start: {
            line: 609,
            column: 8
          },
          end: {
            line: 611,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 609,
            column: 8
          },
          end: {
            line: 611,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 609
      },
      "23": {
        loc: {
          start: {
            line: 609,
            column: 12
          },
          end: {
            line: 609,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 609,
            column: 12
          },
          end: {
            line: 609,
            column: 29
          }
        }, {
          start: {
            line: 609,
            column: 33
          },
          end: {
            line: 609,
            column: 51
          }
        }],
        line: 609
      },
      "24": {
        loc: {
          start: {
            line: 662,
            column: 2
          },
          end: {
            line: 662,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 662,
            column: 2
          },
          end: {
            line: 662,
            column: 41
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 662
      },
      "25": {
        loc: {
          start: {
            line: 663,
            column: 2
          },
          end: {
            line: 663,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 663,
            column: 2
          },
          end: {
            line: 663,
            column: 35
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 663
      },
      "26": {
        loc: {
          start: {
            line: 677,
            column: 2
          },
          end: {
            line: 707,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 677,
            column: 2
          },
          end: {
            line: 707,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 677
      },
      "27": {
        loc: {
          start: {
            line: 677,
            column: 6
          },
          end: {
            line: 677,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 677,
            column: 6
          },
          end: {
            line: 677,
            column: 40
          }
        }, {
          start: {
            line: 677,
            column: 44
          },
          end: {
            line: 677,
            column: 73
          }
        }],
        line: 677
      },
      "28": {
        loc: {
          start: {
            line: 679,
            column: 4
          },
          end: {
            line: 685,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 679,
            column: 4
          },
          end: {
            line: 685,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 679
      },
      "29": {
        loc: {
          start: {
            line: 686,
            column: 4
          },
          end: {
            line: 706,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 686,
            column: 4
          },
          end: {
            line: 706,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 686
      },
      "30": {
        loc: {
          start: {
            line: 688,
            column: 6
          },
          end: {
            line: 690,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 688,
            column: 6
          },
          end: {
            line: 690,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 688
      },
      "31": {
        loc: {
          start: {
            line: 691,
            column: 6
          },
          end: {
            line: 693,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 691,
            column: 6
          },
          end: {
            line: 693,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 691
      },
      "32": {
        loc: {
          start: {
            line: 694,
            column: 21
          },
          end: {
            line: 696,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 695,
            column: 10
          },
          end: {
            line: 695,
            column: 46
          }
        }, {
          start: {
            line: 696,
            column: 10
          },
          end: {
            line: 696,
            column: 43
          }
        }],
        line: 694
      },
      "33": {
        loc: {
          start: {
            line: 697,
            column: 19
          },
          end: {
            line: 699,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 698,
            column: 10
          },
          end: {
            line: 698,
            column: 83
          }
        }, {
          start: {
            line: 699,
            column: 10
          },
          end: {
            line: 699,
            column: 79
          }
        }],
        line: 697
      },
      "34": {
        loc: {
          start: {
            line: 700,
            column: 23
          },
          end: {
            line: 702,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 701,
            column: 10
          },
          end: {
            line: 701,
            column: 62
          }
        }, {
          start: {
            line: 702,
            column: 10
          },
          end: {
            line: 702,
            column: 58
          }
        }],
        line: 700
      },
      "35": {
        loc: {
          start: {
            line: 703,
            column: 24
          },
          end: {
            line: 705,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 704,
            column: 10
          },
          end: {
            line: 704,
            column: 75
          }
        }, {
          start: {
            line: 705,
            column: 10
          },
          end: {
            line: 705,
            column: 71
          }
        }],
        line: 703
      },
      "36": {
        loc: {
          start: {
            line: 740,
            column: 8
          },
          end: {
            line: 740,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 740,
            column: 8
          },
          end: {
            line: 740,
            column: 19
          }
        }, {
          start: {
            line: 740,
            column: 23
          },
          end: {
            line: 740,
            column: 31
          }
        }, {
          start: {
            line: 740,
            column: 35
          },
          end: {
            line: 740,
            column: 42
          }
        }],
        line: 740
      },
      "37": {
        loc: {
          start: {
            line: 741,
            column: 24
          },
          end: {
            line: 741,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 741,
            column: 25
          },
          end: {
            line: 741,
            column: 36
          }
        }, {
          start: {
            line: 741,
            column: 40
          },
          end: {
            line: 741,
            column: 61
          }
        }, {
          start: {
            line: 741,
            column: 67
          },
          end: {
            line: 741,
            column: 74
          }
        }, {
          start: {
            line: 741,
            column: 78
          },
          end: {
            line: 741,
            column: 95
          }
        }],
        line: 741
      },
      "38": {
        loc: {
          start: {
            line: 743,
            column: 24
          },
          end: {
            line: 743,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 743,
            column: 24
          },
          end: {
            line: 743,
            column: 47
          }
        }, {
          start: {
            line: 743,
            column: 51
          },
          end: {
            line: 743,
            column: 62
          }
        }],
        line: 743
      },
      "39": {
        loc: {
          start: {
            line: 744,
            column: 36
          },
          end: {
            line: 744,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 744,
            column: 36
          },
          end: {
            line: 744,
            column: 46
          }
        }, {
          start: {
            line: 744,
            column: 50
          },
          end: {
            line: 744,
            column: 64
          }
        }],
        line: 744
      },
      "40": {
        loc: {
          start: {
            line: 745,
            column: 26
          },
          end: {
            line: 745,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 745,
            column: 26
          },
          end: {
            line: 745,
            column: 36
          }
        }, {
          start: {
            line: 745,
            column: 40
          },
          end: {
            line: 745,
            column: 68
          }
        }],
        line: 745
      },
      "41": {
        loc: {
          start: {
            line: 746,
            column: 33
          },
          end: {
            line: 746,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 746,
            column: 33
          },
          end: {
            line: 746,
            column: 43
          }
        }, {
          start: {
            line: 746,
            column: 47
          },
          end: {
            line: 746,
            column: 58
          }
        }],
        line: 746
      },
      "42": {
        loc: {
          start: {
            line: 761,
            column: 11
          },
          end: {
            line: 770,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 761,
            column: 11
          },
          end: {
            line: 761,
            column: 29
          }
        }, {
          start: {
            line: 762,
            column: 12
          },
          end: {
            line: 762,
            column: 34
          }
        }, {
          start: {
            line: 763,
            column: 14
          },
          end: {
            line: 769,
            column: 16
          }
        }],
        line: 761
      },
      "43": {
        loc: {
          start: {
            line: 771,
            column: 11
          },
          end: {
            line: 776,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 771,
            column: 11
          },
          end: {
            line: 771,
            column: 43
          }
        }, {
          start: {
            line: 772,
            column: 12
          },
          end: {
            line: 775,
            column: 14
          }
        }],
        line: 771
      },
      "44": {
        loc: {
          start: {
            line: 785,
            column: 11
          },
          end: {
            line: 796,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 785,
            column: 11
          },
          end: {
            line: 785,
            column: 25
          }
        }, {
          start: {
            line: 786,
            column: 12
          },
          end: {
            line: 795,
            column: 29
          }
        }],
        line: 785
      },
      "45": {
        loc: {
          start: {
            line: 809,
            column: 32
          },
          end: {
            line: 809,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 809,
            column: 32
          },
          end: {
            line: 809,
            column: 41
          }
        }, {
          start: {
            line: 809,
            column: 45
          },
          end: {
            line: 809,
            column: 59
          }
        }],
        line: 809
      },
      "46": {
        loc: {
          start: {
            line: 826,
            column: 8
          },
          end: {
            line: 829,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 826,
            column: 8
          },
          end: {
            line: 829,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 826
      },
      "47": {
        loc: {
          start: {
            line: 832,
            column: 16
          },
          end: {
            line: 832,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 832,
            column: 26
          },
          end: {
            line: 832,
            column: 54
          }
        }, {
          start: {
            line: 832,
            column: 57
          },
          end: {
            line: 832,
            column: 84
          }
        }],
        line: 832
      },
      "48": {
        loc: {
          start: {
            line: 835,
            column: 8
          },
          end: {
            line: 870,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 835,
            column: 8
          },
          end: {
            line: 870,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 835
      },
      "49": {
        loc: {
          start: {
            line: 854,
            column: 18
          },
          end: {
            line: 856,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 855,
            column: 22
          },
          end: {
            line: 855,
            column: 70
          }
        }, {
          start: {
            line: 856,
            column: 22
          },
          end: {
            line: 856,
            column: 71
          }
        }],
        line: 854
      },
      "50": {
        loc: {
          start: {
            line: 859,
            column: 18
          },
          end: {
            line: 864,
            column: 26
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 860,
            column: 20
          },
          end: {
            line: 863,
            column: 22
          }
        }, {
          start: {
            line: 864,
            column: 22
          },
          end: {
            line: 864,
            column: 26
          }
        }],
        line: 859
      },
      "51": {
        loc: {
          start: {
            line: 873,
            column: 13
          },
          end: {
            line: 888,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 873,
            column: 13
          },
          end: {
            line: 873,
            column: 28
          }
        }, {
          start: {
            line: 874,
            column: 14
          },
          end: {
            line: 874,
            column: 23
          }
        }, {
          start: {
            line: 875,
            column: 16
          },
          end: {
            line: 887,
            column: 22
          }
        }],
        line: 873
      },
      "52": {
        loc: {
          start: {
            line: 904,
            column: 11
          },
          end: {
            line: 904,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 904,
            column: 11
          },
          end: {
            line: 904,
            column: 22
          }
        }, {
          start: {
            line: 904,
            column: 26
          },
          end: {
            line: 904,
            column: 46
          }
        }],
        line: 904
      },
      "53": {
        loc: {
          start: {
            line: 905,
            column: 11
          },
          end: {
            line: 905,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 905,
            column: 11
          },
          end: {
            line: 905,
            column: 23
          }
        }, {
          start: {
            line: 905,
            column: 27
          },
          end: {
            line: 905,
            column: 48
          }
        }, {
          start: {
            line: 905,
            column: 52
          },
          end: {
            line: 905,
            column: 73
          }
        }],
        line: 905
      },
      "54": {
        loc: {
          start: {
            line: 906,
            column: 11
          },
          end: {
            line: 906,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 906,
            column: 11
          },
          end: {
            line: 906,
            column: 20
          }
        }, {
          start: {
            line: 906,
            column: 24
          },
          end: {
            line: 906,
            column: 42
          }
        }],
        line: 906
      },
      "55": {
        loc: {
          start: {
            line: 907,
            column: 11
          },
          end: {
            line: 907,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 907,
            column: 11
          },
          end: {
            line: 907,
            column: 29
          }
        }, {
          start: {
            line: 907,
            column: 33
          },
          end: {
            line: 907,
            column: 60
          }
        }],
        line: 907
      },
      "56": {
        loc: {
          start: {
            line: 989,
            column: 11
          },
          end: {
            line: 989,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 989,
            column: 25
          },
          end: {
            line: 989,
            column: 39
          }
        }, {
          start: {
            line: 989,
            column: 42
          },
          end: {
            line: 989,
            column: 51
          }
        }],
        line: 989
      },
      "57": {
        loc: {
          start: {
            line: 1003,
            column: 26
          },
          end: {
            line: 1003,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1003,
            column: 26
          },
          end: {
            line: 1003,
            column: 66
          }
        }, {
          start: {
            line: 1003,
            column: 70
          },
          end: {
            line: 1003,
            column: 81
          }
        }],
        line: 1003
      },
      "58": {
        loc: {
          start: {
            line: 1006,
            column: 29
          },
          end: {
            line: 1006,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1006,
            column: 29
          },
          end: {
            line: 1006,
            column: 56
          }
        }, {
          start: {
            line: 1006,
            column: 60
          },
          end: {
            line: 1006,
            column: 91
          }
        }],
        line: 1006
      },
      "59": {
        loc: {
          start: {
            line: 1043,
            column: 10
          },
          end: {
            line: 1043,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1043,
            column: 10
          },
          end: {
            line: 1043,
            column: 32
          }
        }, {
          start: {
            line: 1043,
            column: 36
          },
          end: {
            line: 1043,
            column: 51
          }
        }, {
          start: {
            line: 1043,
            column: 55
          },
          end: {
            line: 1043,
            column: 66
          }
        }, {
          start: {
            line: 1043,
            column: 70
          },
          end: {
            line: 1043,
            column: 88
          }
        }],
        line: 1043
      },
      "60": {
        loc: {
          start: {
            line: 1056,
            column: 7
          },
          end: {
            line: 1071,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1056,
            column: 7
          },
          end: {
            line: 1056,
            column: 20
          }
        }, {
          start: {
            line: 1057,
            column: 8
          },
          end: {
            line: 1070,
            column: 27
          }
        }],
        line: 1056
      },
      "61": {
        loc: {
          start: {
            line: 1059,
            column: 13
          },
          end: {
            line: 1063,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 1060,
            column: 14
          },
          end: {
            line: 1060,
            column: 80
          }
        }, {
          start: {
            line: 1062,
            column: 14
          },
          end: {
            line: 1062,
            column: 92
          }
        }],
        line: 1059
      },
      "62": {
        loc: {
          start: {
            line: 1064,
            column: 13
          },
          end: {
            line: 1068,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1064,
            column: 13
          },
          end: {
            line: 1064,
            column: 35
          }
        }, {
          start: {
            line: 1065,
            column: 14
          },
          end: {
            line: 1067,
            column: 23
          }
        }],
        line: 1064
      },
      "63": {
        loc: {
          start: {
            line: 1072,
            column: 7
          },
          end: {
            line: 1072,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1072,
            column: 7
          },
          end: {
            line: 1072,
            column: 31
          }
        }, {
          start: {
            line: 1072,
            column: 35
          },
          end: {
            line: 1072,
            column: 50
          }
        }, {
          start: {
            line: 1072,
            column: 54
          },
          end: {
            line: 1072,
            column: 65
          }
        }, {
          start: {
            line: 1072,
            column: 69
          },
          end: {
            line: 1072,
            column: 87
          }
        }],
        line: 1072
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0, 0],
      "37": [0, 0, 0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0, 0],
      "52": [0, 0],
      "53": [0, 0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0, 0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6f16862344bf6965cbb3f39397b51ca700ae2231"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_xmzdhde1r = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_xmzdhde1r();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var ACCESSIBILITY_TITLE_PREFIX = (cov_xmzdhde1r().s[0]++, 'accessibility_title_');
var Wrapper = (cov_xmzdhde1r().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_xmzdhde1r().f[0]++;
    cov_xmzdhde1r().s[2]++;
    return "stx-ProductLine stx-ProductLine-".concat(props.productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n      padding: ", " ", ";\n      position: relative;\n    "])), _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.medium)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n      position: relative;\n      padding: ", ";\n      border-radius: var(--generalBorderRadius, 12px);\n      ", ";\n      background-color: ", ";\n      gap: 24px;\n      .stx-MainContent {\n        .stx-product-content {\n          gap: ", ";\n          div:not(.stx-Advantage):not(.stx-AdvantageIndicator) {\n            padding: 0;\n            margin: 0;\n            .stx-ProductCardTitle {\n              margin: 0;\n            }\n          }\n          .stx-ProductDate .g-Icon {\n            width: 16px;\n            height: 18px;\n            color: var(--subtleTextColor, #7f8c8d);\n          }\n          div .g-Icon {\n            color: var(--subtleTextColor, #7f8c8d);\n            font-size: ", ";\n            line-height: var(--date-line-height);\n            margin-bottom: 0;\n            margin-right: 8px;\n            width: 16px;\n            height: 18px;\n          }\n\n          --date-color: var(--subtleTextColor, #7f8c8d);\n          --date-line-height: ", ";\n          --date-font-size: ", ";\n\n          p.semantic-no-styling {\n            color: var(--date-color);\n            font-size: var(--date-font-size);\n            line-height: var(--date-line-height);\n            font-weight: ", ";\n          }\n        }\n      }\n    "])), function (_ref) {
  var theme = _ref.theme;
  cov_xmzdhde1r().f[1]++;
  cov_xmzdhde1r().s[3]++;
  return (cov_xmzdhde1r().b[0][0]++, theme.spacingX) || (cov_xmzdhde1r().b[0][1]++, '12px');
}, (0, _utils.boxShadowOf)('Card', {
  defaultValue: (0, _get.default)(_themeMapper.evolutionTheme, 'productLine.boxShadow')
}), function (_ref2) {
  var theme = _ref2.theme;
  cov_xmzdhde1r().f[2]++;
  cov_xmzdhde1r().s[4]++;
  return (cov_xmzdhde1r().b[1][0]++, theme.contentBgColor) || (cov_xmzdhde1r().b[1][1]++, '#ffffff');
}, function (_ref3) {
  var theme = _ref3.theme;
  cov_xmzdhde1r().f[3]++;
  cov_xmzdhde1r().s[5]++;
  return (cov_xmzdhde1r().b[2][0]++, theme.spacingY) || (cov_xmzdhde1r().b[2][1]++, '16px');
}, _themeMapper.evolutionTheme.typography.body2.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.fontWeight.normal))));
var RightContentWrapper = (cov_xmzdhde1r().s[6]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: function className(props) {
    cov_xmzdhde1r().f[4]++;
    cov_xmzdhde1r().s[7]++;
    return "stx-RightContent stx-ActionButtonContainer stx-ActionButtonContainer-".concat(props.productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      @media screen and (max-width: 52em) {\n        width: 100%;\n        max-width: 100%;\n      }\n      button,\n      a {\n        width: 100%;\n        max-width: 100%;\n      }\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      ", ";\n\n      button,\n      a {\n        width: 100%;\n        max-width: 100%;\n      }\n\n      ", ";\n\n      > .stx-ProductLineActionButton {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        > .stx-RightContentButtonWrapper {\n          width: 100%;\n        }\n\n        > .stx-ProductActions {\n          > .stx-ProductActions-BoxWrapper {\n            width: 100%;\n          }\n\n          :empty {\n            display: none;\n          }\n        }\n      }\n\n      > .stx-ComingSoonContent {\n        align-items: center;\n      }\n    "])), _utils.gDesktopFirstMediaQueries.lg(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n          width: 100%;\n          max-width: 100%;\n      "]))), function (_ref4) {
  var column = _ref4.column;
  cov_xmzdhde1r().f[5]++;
  cov_xmzdhde1r().s[8]++;
  return (cov_xmzdhde1r().b[3][0]++, column) && (cov_xmzdhde1r().b[3][1]++, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n          flex-direction: column;\n        "]))));
}))));
var RestrictedAdvBox = (cov_xmzdhde1r().s[9]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'stx-RestrictedAdvBox'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: ", ";\n    "])), _stylingConstants.default.font.sizeS)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: ", ";\n    "])), _themeMapper.evolutionTheme.typography.caption2.fontSize))));
var MatchDate = (cov_xmzdhde1r().s[10]++, (0, _styledComponents.default)(_ProductDate.default).attrs({
  className: 'stx-MatchDate'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: ", ";\n"])), _stylingConstants.default.font.sizeS));
var ImageWrapper = (cov_xmzdhde1r().s[11]++, _styledComponents.default.div.attrs({
  className: 'stx-backdropContainer'
})(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  height: 100%;\n  width: 100%;\n  position: relative;\n"]))));
var MatchIndicator = (cov_xmzdhde1r().s[12]++, (0, _styledComponents.default)(_ProductIndicator.default).attrs({
  className: 'stx-matchIndicator'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  top: 0;\n  right: 0;\n"]))));
var CenterText = (cov_xmzdhde1r().s[13]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'stx-RightContentText'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: center;\n      text-transform: uppercase;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: center;\n      color: var(--textColor, #212121);\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n    "])), (0, _get.default)(_themeMapper.evolutionTheme, 'typography.caption1.fontSize'), (0, _get.default)(_themeMapper.evolutionTheme, 'typography.caption1.lineHeight'), (0, _get.default)(_themeMapper.evolutionTheme, 'fontWeight.medium')))));
var FlexCenteredOnPhone = (cov_xmzdhde1r().s[14]++, (0, _styledComponents.default)(_gridStyled.Flex)(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  @media screen and (max-width: 40em) {\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n  }\n"]))));
var FixedWrapper = (cov_xmzdhde1r().s[15]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "stx-FixedWrapper"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      @media screen and (max-width: 40em) {\n        width: ", ";\n        margin-left: auto;\n        margin-right: auto;\n        min-width: 100px;\n        max-width: 250px;\n      }\n    "])), function (props) {
  cov_xmzdhde1r().f[6]++;
  cov_xmzdhde1r().s[16]++;
  return props.desktopWidth;
}, function (props) {
  cov_xmzdhde1r().f[7]++;
  cov_xmzdhde1r().s[17]++;
  return props.phoneWidth;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      align-self: flex-start;\n      ", ";\n    "])), function (props) {
  cov_xmzdhde1r().f[8]++;
  cov_xmzdhde1r().s[18]++;
  return props.phoneWidth;
}, _utils.gMediaQueries.lg(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n        width: 148px;\n        max-height: 216px;\n      "])))))));
var MainContentWrapper = (cov_xmzdhde1r().s[19]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'stx-MainContent'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n    flex: 1;\n    margin-left: 1rem;\n\n    @media screen and (max-width: ", ") {\n      width: 100%;\n      flex: none;\n      margin-left: 0;\n      padding: 0;\n      padding: 0.5rem 0 0 0;\n    }\n  "])), function (_ref5) {
  var _ref5$mobileWidth = _ref5.mobileWidth,
    mobileWidth = _ref5$mobileWidth === void 0 ? (cov_xmzdhde1r().b[4][0]++, '40em') : _ref5$mobileWidth;
  cov_xmzdhde1r().f[9]++;
  cov_xmzdhde1r().s[20]++;
  return mobileWidth;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2.default)(["\n    flex: 1;\n    padding: 0;\n    align-self: self-start;\n\n    @media screen and (max-width: ", ") {\n      width: 100%;\n      flex: none;\n    }\n  "])), function (_ref6) {
  var _ref6$mobileWidth = _ref6.mobileWidth,
    mobileWidth = _ref6$mobileWidth === void 0 ? (cov_xmzdhde1r().b[5][0]++, '391px') : _ref6$mobileWidth;
  cov_xmzdhde1r().f[10]++;
  cov_xmzdhde1r().s[21]++;
  return mobileWidth;
}))));
var MatchWrapper = (cov_xmzdhde1r().s[22]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject20 || (_templateObject20 = (0, _taggedTemplateLiteral2.default)(["\n    position: static;\n    top: 1rem;\n    @media screen and (max-width: 40em) {\n      position: relative;\n      top: 0;\n    }\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject21 || (_templateObject21 = (0, _taggedTemplateLiteral2.default)(["\n    flex-wrap: wrap;\n  "]))))));
var CustomWidth = (cov_xmzdhde1r().s[23]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject22 || (_templateObject22 = (0, _taggedTemplateLiteral2.default)(["\n    flex-direction: column;\n    width: ", ";\n    @media screen and (max-width: 40em) {\n      width: 100%;\n      text-align: center;\n    }\n  "])), function (props) {
  cov_xmzdhde1r().f[11]++;
  cov_xmzdhde1r().s[24]++;
  return props.width;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject23 || (_templateObject23 = (0, _taggedTemplateLiteral2.default)(["\n    width: 100%;\n    flex-direction: column;\n    text-align: left;\n    justify-content: center;\n\n    ", ";\n\n    .stx-matchIndicator {\n      margin-bottom: ", "px;\n    }\n  "])), _utils.gMediaQueries.lg(_templateObject24 || (_templateObject24 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      text-align: initial;\n    "])), function (props) {
  cov_xmzdhde1r().f[12]++;
  cov_xmzdhde1r().s[25]++;
  return props.width;
}), (_themeMapper.evolutionTheme, 'spacings.lg', 16)))));
var RightContentButton = (cov_xmzdhde1r().s[26]++, (0, _styledComponents.default)(_button.default)(_templateObject25 || (_templateObject25 = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n  display: flex;\n  margin-top: 0.5rem;\n  height: 100%;\n  line-height: 17px;\n  padding: 0.7rem 1rem;\n  span {\n    margin: auto;\n  }\n"]))));
var RelativeProductIndicator = (cov_xmzdhde1r().s[27]++, (0, _styledComponents.default)(_ProductIndicator.default)(_templateObject26 || (_templateObject26 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  top: 0;\n  right: 0;\n"]))));
var AccessibilityHeading = (cov_xmzdhde1r().s[28]++, _styledComponents.default.h3.attrs({
  className: 'accessibility-visually-hidden'
})(_templateObject27 || (_templateObject27 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"]))));
var AccessibilityTitleContent = (cov_xmzdhde1r().s[29]++, _styledComponents.default.span.attrs({
  className: 'accessibility-visually-hidden'
})(_templateObject28 || (_templateObject28 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"]))));
var BoxSoldOutContent = (cov_xmzdhde1r().s[30]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "stx-souldOutContent"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject29 || (_templateObject29 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: column;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject30 || (_templateObject30 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      > .stx-ProductActions {\n        > .stx-ProductActions-BoxWrapper {\n          width: 100%;\n        }\n      }\n    "]))))));
cov_xmzdhde1r().s[31]++;
var ProductContent = function ProductContent(_ref7) {
  var product = _ref7.product,
    timeslot = _ref7.timeslot,
    performance = _ref7.performance,
    replaceProductNameByPerformance = _ref7.replaceProductNameByPerformance,
    productDescription = _ref7.productDescription;
  cov_xmzdhde1r().f[13]++;
  // Display as normal
  var productSubtitle = (cov_xmzdhde1r().s[32]++, _ProductHelper.default.getProductSubtitle({
    product: product,
    performance: performance
  }));
  var location = (cov_xmzdhde1r().s[33]++, product.location);
  cov_xmzdhde1r().s[34]++;
  return /*#__PURE__*/_react.default.createElement(FlexCenteredOnPhone, {
    direction: 'column',
    className: "stx-product-content",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 399,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
    py: [0, 1, 1],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 400,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(RelativeProductIndicator, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 401,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react.default.createElement(_ProductTitle.NonHeadingTitle, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 402,
      columnNumber: 9
    }
  }, _ProductHelper.default.getProductTitle({
    product: product,
    performance: performance,
    intl: null,
    usePerformanceName: replaceProductNameByPerformance
  })), (cov_xmzdhde1r().b[6][0]++, productSubtitle) && (cov_xmzdhde1r().b[6][1]++, /*#__PURE__*/_react.default.createElement(_ProductTitle.SubTitle, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 410,
      columnNumber: 29
    }
  }, productSubtitle))), /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
    py: [0, 1, 1],
    direction: 'column',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 412,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductDate.default, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 413,
      columnNumber: 9
    }
  }), (cov_xmzdhde1r().b[7][0]++, location) && (cov_xmzdhde1r().b[7][1]++, /*#__PURE__*/_react.default.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 415,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductDescriptionIcon.default, {
    iconName: "riMapPinLine",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 416,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "semantic-no-styling",
    style: {
      display: 'inline-block'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 417,
      columnNumber: 13
    }
  }, location)))), productDescription);
};
cov_xmzdhde1r().s[35]++;
ProductContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  replaceProductNameByPerformance: _propTypes.default.bool,
  productDescription: _propTypes.default.node
};
cov_xmzdhde1r().s[36]++;
ProductContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  replaceProductNameByPerformance: false,
  productDescription: null
};
var MatchContentLocationWrapper = (cov_xmzdhde1r().s[37]++, (0, _utils.withThemedStyles)(_styledComponents.default.div, (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject31 || (_templateObject31 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n  "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.fontWeight.normal))));
var MatchContent = (cov_xmzdhde1r().s[38]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(function (_ref8) {
  var product = _ref8.product,
    performance = _ref8.performance,
    themeQueries = _ref8.themeQueries,
    productDescription = _ref8.productDescription;
  cov_xmzdhde1r().f[14]++;
  cov_xmzdhde1r().s[39]++;
  return /*#__PURE__*/_react.default.createElement(MatchWrapper, {
    flexWrap: ['wrap-reverse'],
    justify: 'baseline',
    width: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 456,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(CustomWidth, {
    direction: 'column',
    width: "30%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 457,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 458,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(MatchIndicator, {
    product: product,
    performance: performance,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 459,
      columnNumber: 11
    }
  })), ((cov_xmzdhde1r().b[8][0]++, product.roundName) || (cov_xmzdhde1r().b[8][1]++, themeQueries.EQUILIBRIUM)) && (cov_xmzdhde1r().b[8][2]++, /*#__PURE__*/_react.default.createElement("span", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 461,
      columnNumber: 61
    }
  }, product.roundName)), /*#__PURE__*/_react.default.createElement(MatchDate, {
    product: product,
    performance: performance,
    showTime: true,
    showIcon: !themeQueries.EVOLUTION,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 462,
      columnNumber: 9
    }
  }), ((cov_xmzdhde1r().b[9][0]++, performance.venue) || (cov_xmzdhde1r().b[9][1]++, product.location)) && (cov_xmzdhde1r().b[9][2]++, /*#__PURE__*/_react.default.createElement(MatchContentLocationWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 469,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductDescriptionIcon.default, {
    iconName: themeQueries.EVOLUTION ? (cov_xmzdhde1r().b[10][0]++, "riMapPinLine") : (cov_xmzdhde1r().b[10][1]++, "map"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 470,
      columnNumber: 13
    }
  }), (cov_xmzdhde1r().b[11][0]++, performance.venue) || (cov_xmzdhde1r().b[11][1]++, product.location))), (cov_xmzdhde1r().b[12][0]++, !performance.finalDate) && (cov_xmzdhde1r().b[12][1]++, /*#__PURE__*/_react.default.createElement(_DateLabel.default, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 475,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.dateToBeConfirmed",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 476,
      columnNumber: 13
    }
  })))), /*#__PURE__*/_react.default.createElement(CustomWidth, {
    justify: "center",
    width: "62%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 481,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_MatchTeamDetail.default, {
    hostTeam: performance.hostTeam,
    opposingTeam: performance.opposingTeam,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 482,
      columnNumber: 9
    }
  })), (cov_xmzdhde1r().b[13][0]++, themeQueries.EVOLUTION) && (cov_xmzdhde1r().b[13][1]++, /*#__PURE__*/_react.default.createElement(CustomWidth, {
    width: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 484,
      columnNumber: 34
    }
  }, productDescription)));
})));
cov_xmzdhde1r().s[40]++;
MatchContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  themeContext: _themeProvider.ThemeContextType
};
cov_xmzdhde1r().s[41]++;
MatchContent.defaultProps = {
  performance: undefined,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};
var MainContent = (cov_xmzdhde1r().s[42]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(function (_ref9) {
  var product = _ref9.product,
    performance = _ref9.performance,
    timeslot = _ref9.timeslot,
    isMatch = _ref9.isMatch,
    intl = _ref9.intl,
    themeQueries = _ref9.themeQueries,
    productDescription = _ref9.productDescription;
  cov_xmzdhde1r().f[15]++;
  cov_xmzdhde1r().s[43]++;
  return /*#__PURE__*/_react.default.createElement(MainContentWrapper, {
    auto: true,
    p: themeQueries.EQUILIBRIUM ? (cov_xmzdhde1r().b[14][0]++, [0, 1]) : (cov_xmzdhde1r().b[14][1]++, [0, 0, 0, 1]),
    py: [2, 0],
    mobileWidth: themeQueries.EVOLUTION ? (cov_xmzdhde1r().b[15][0]++, "".concat(_themeMapper.evolutionTheme.breakpoints.lg - 1, "px")) : (cov_xmzdhde1r().b[15][1]++, undefined),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 505,
      columnNumber: 7
    }
  }, isMatch ? (cov_xmzdhde1r().b[16][0]++, /*#__PURE__*/_react.default.createElement(MatchContent, {
    product: product,
    performance: performance,
    productDescription: productDescription,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 511,
      columnNumber: 11
    }
  })) : (cov_xmzdhde1r().b[16][1]++, /*#__PURE__*/_react.default.createElement(ProductContent, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    intl: intl,
    productDescription: productDescription,
    replaceProductNameByPerformance: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 517,
      columnNumber: 11
    }
  })));
})));
cov_xmzdhde1r().s[44]++;
MainContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Display as match or normal product */
  isMatch: _propTypes.default.bool.isRequired,
  /* get the possiblity to get internationalization */
  intl: _reactIntl.intlShape.isRequired,
  replaceProductNameByPerformance: _propTypes.default.bool,
  themeContext: _themeProvider.ThemeContextType
};
cov_xmzdhde1r().s[45]++;
MainContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  replaceProductNameByPerformance: false,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};

/** Display image of product line */
var LeftContent = (cov_xmzdhde1r().s[46]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withMediaQueries)((0, _utils.withThemeQueries)(function (_ref10) {
  var product = _ref10.product,
    performance = _ref10.performance,
    isMatch = _ref10.isMatch,
    isLandingPage = _ref10.isLandingPage,
    ecommerceGoogleTracking = _ref10.ecommerceGoogleTracking,
    productTitle = _ref10.productTitle,
    mediaQueries = _ref10.mediaQueries,
    themeQueries = _ref10.themeQueries,
    lastItemId = _ref10.lastItemId;
  cov_xmzdhde1r().f[16]++;
  var aspectRatio = (cov_xmzdhde1r().s[47]++, function () {
    cov_xmzdhde1r().f[17]++;
    cov_xmzdhde1r().s[48]++;
    if (themeQueries.EQUILIBRIUM) {
      cov_xmzdhde1r().b[17][0]++;
      cov_xmzdhde1r().s[49]++;
      return 'VERTICAL';
    } else {
      cov_xmzdhde1r().b[17][1]++;
    }
    cov_xmzdhde1r().s[50]++;
    return mediaQueries.lg ? (cov_xmzdhde1r().b[18][0]++, 'SQUARE') : (cov_xmzdhde1r().b[18][1]++, 'LANDSCAPE');
  }());
  cov_xmzdhde1r().s[51]++;
  if (isMatch) {
    cov_xmzdhde1r().b[19][0]++;
    cov_xmzdhde1r().s[52]++;
    return /*#__PURE__*/_react.default.createElement(FixedWrapper, {
      desktopWidth: themeQueries.EQUILIBRIUM ? (cov_xmzdhde1r().b[20][0]++, '60px') : (cov_xmzdhde1r().b[20][1]++, '70px'),
      phoneWidth: themeQueries.EQUILIBRIUM ? (cov_xmzdhde1r().b[21][0]++, '25%') : (cov_xmzdhde1r().b[21][1]++, '100%'),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 578,
        columnNumber: 13
      }
    }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
      product: product,
      performance: performance,
      aspectRatio: aspectRatio,
      tooltip: product.name,
      ecommerceGoogleTracking: ecommerceGoogleTracking,
      isLandingPage: isLandingPage,
      resizeMode: "contain",
      lastItemId: lastItemId,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 581,
        columnNumber: 15
      }
    }));
  } else {
    cov_xmzdhde1r().b[19][1]++;
  }
  var image = (cov_xmzdhde1r().s[53]++, /*#__PURE__*/_react.default.createElement(ImageWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 596,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
    product: product,
    performance: performance,
    aspectRatio: "WIDE",
    tooltip: productTitle,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    isLandingPage: isLandingPage,
    lastItemId: lastItemId,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 597,
      columnNumber: 13
    }
  })));
  cov_xmzdhde1r().s[54]++;
  if ((cov_xmzdhde1r().b[23][0]++, product.isSoldOut) || (cov_xmzdhde1r().b[23][1]++, product.notOnSales)) {
    cov_xmzdhde1r().b[22][0]++;
    cov_xmzdhde1r().s[55]++;
    image = /*#__PURE__*/_react.default.createElement(_backdrop.default, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 610,
        columnNumber: 19
      }
    }, image);
  } else {
    cov_xmzdhde1r().b[22][1]++;
  }
  cov_xmzdhde1r().s[56]++;
  return /*#__PURE__*/_react.default.createElement(FixedWrapper, {
    desktopWidth: "180px",
    phoneWidth: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 613,
      columnNumber: 11
    }
  }, image);
}))));
cov_xmzdhde1r().s[57]++;
LeftContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* Display as match or normal product */
  isMatch: _propTypes.default.bool.isRequired,
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Option to use google enhance tracking to push data to data layer */
  productTitle: _propTypes.default.string,
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  themeContext: _themeProvider.ThemeContextType,
  mediaQueries: _utils.WithMediaQueriesType,
  lastItemId: _propTypes.default.number
};
cov_xmzdhde1r().s[58]++;
LeftContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  isLandingPage: false,
  productTitle: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  mediaQueries: {},
  lastItemId: 0
};
var SoldOutLabel = (cov_xmzdhde1r().s[59]++, (0, _styledComponents.default)(CenterText)(_templateObject32 || (_templateObject32 = (0, _taggedTemplateLiteral2.default)(["\n  color: #ff4f4f;\n"]))));
var SalesStartDate = (cov_xmzdhde1r().s[60]++, (0, _styledComponents.default)(CenterText)(_templateObject33 || (_templateObject33 = (0, _taggedTemplateLiteral2.default)(["\n  color: gray;\n  text-transform: none;\n"]))));
cov_xmzdhde1r().s[61]++;
var getAccessibilityTitleId = function getAccessibilityTitleId(product, performance, timeslot) {
  cov_xmzdhde1r().f[18]++;
  cov_xmzdhde1r().s[62]++;
  if (performance) {
    cov_xmzdhde1r().b[24][0]++;
    cov_xmzdhde1r().s[63]++;
    return performance.id;
  } else {
    cov_xmzdhde1r().b[24][1]++;
  }
  cov_xmzdhde1r().s[64]++;
  if (timeslot) {
    cov_xmzdhde1r().b[25][0]++;
    cov_xmzdhde1r().s[65]++;
    return timeslot.id;
  } else {
    cov_xmzdhde1r().b[25][1]++;
  }
  cov_xmzdhde1r().s[66]++;
  return product.id;
};
cov_xmzdhde1r().s[67]++;
var buildStreamOnlineConfig = function buildStreamOnlineConfig(product, performance, timeslot, displayAs) {
  cov_xmzdhde1r().f[19]++;
  var shouldDisplayWatchNow = (cov_xmzdhde1r().s[68]++, false);
  var productId = (cov_xmzdhde1r().s[69]++, null);
  var performanceId = (cov_xmzdhde1r().s[70]++, null);
  var timeslotId = (cov_xmzdhde1r().s[71]++, null);
  var buyActionUrl = (cov_xmzdhde1r().s[72]++, null);
  var accessCode = (cov_xmzdhde1r().s[73]++, '');
  var isAlreadyWatch = (cov_xmzdhde1r().s[74]++, false);
  var isLoginRequired = (cov_xmzdhde1r().s[75]++, false);
  cov_xmzdhde1r().s[76]++;
  if ((cov_xmzdhde1r().b[27][0]++, product.streamOnline !== undefined) && (cov_xmzdhde1r().b[27][1]++, product.streamOnline !== null)) {
    cov_xmzdhde1r().b[26][0]++;
    cov_xmzdhde1r().s[77]++;
    shouldDisplayWatchNow = true;
    cov_xmzdhde1r().s[78]++;
    if (displayAs === 'PRODUCT') {
      cov_xmzdhde1r().b[28][0]++;
      cov_xmzdhde1r().s[79]++;
      productId = product.id;
      cov_xmzdhde1r().s[80]++;
      buyActionUrl = (0, _get.default)(product, 'action.buy', null);
      cov_xmzdhde1r().s[81]++;
      accessCode = (0, _get.default)(product, 'streamOnline.streamContentValue.accessCredentials', '');
      cov_xmzdhde1r().s[82]++;
      isAlreadyWatch = (0, _get.default)(product, 'streamOnline.alreadyWatch', false);
      cov_xmzdhde1r().s[83]++;
      isLoginRequired = (0, _get.default)(product, 'streamOnline.publicTariffLoginRequired', false);
    } else {
      cov_xmzdhde1r().b[28][1]++;
    }
    cov_xmzdhde1r().s[84]++;
    if (displayAs === 'PERFORMANCE') {
      cov_xmzdhde1r().b[29][0]++;
      cov_xmzdhde1r().s[85]++;
      productId = product.id;
      cov_xmzdhde1r().s[86]++;
      if (performance) {
        cov_xmzdhde1r().b[30][0]++;
        cov_xmzdhde1r().s[87]++;
        performanceId = performance.id;
      } else {
        cov_xmzdhde1r().b[30][1]++;
      }
      cov_xmzdhde1r().s[88]++;
      if (timeslot) {
        cov_xmzdhde1r().b[31][0]++;
        cov_xmzdhde1r().s[89]++;
        timeslotId = timeslot.id;
      } else {
        cov_xmzdhde1r().b[31][1]++;
      }
      cov_xmzdhde1r().s[90]++;
      buyActionUrl = performance ? (cov_xmzdhde1r().b[32][0]++, (0, _get.default)(performance, 'action.buy', null)) : (cov_xmzdhde1r().b[32][1]++, (0, _get.default)(timeslot, 'action.buy', null));
      cov_xmzdhde1r().s[91]++;
      accessCode = performance ? (cov_xmzdhde1r().b[33][0]++, (0, _get.default)(performance, 'streamOnline.streamContentValue.accessCredentials', '')) : (cov_xmzdhde1r().b[33][1]++, (0, _get.default)(product, 'streamOnline.streamContentValue.accessCredentials', ''));
      cov_xmzdhde1r().s[92]++;
      isAlreadyWatch = performance ? (cov_xmzdhde1r().b[34][0]++, (0, _get.default)(performance, 'streamOnline.alreadyWatch', false)) : (cov_xmzdhde1r().b[34][1]++, (0, _get.default)(product, 'streamOnline.alreadyWatch', false));
      cov_xmzdhde1r().s[93]++;
      isLoginRequired = performance ? (cov_xmzdhde1r().b[35][0]++, (0, _get.default)(performance, 'streamOnline.publicTariffLoginRequired', false)) : (cov_xmzdhde1r().b[35][1]++, (0, _get.default)(product, 'streamOnline.publicTariffLoginRequired', false));
    } else {
      cov_xmzdhde1r().b[29][1]++;
    }
  } else {
    cov_xmzdhde1r().b[26][1]++;
  }
  cov_xmzdhde1r().s[94]++;
  return {
    shouldDisplayWatchNow: shouldDisplayWatchNow,
    productId: productId,
    performanceId: performanceId,
    timeslotId: timeslotId,
    buyActionUrl: buyActionUrl,
    accessCode: accessCode,
    isAlreadyWatch: isAlreadyWatch,
    isLoginRequired: isLoginRequired
  };
};

/** Contains action button & sale start date info */
var RightContent = (cov_xmzdhde1r().s[95]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(function (_ref11) {
  var product = _ref11.product,
    performance = _ref11.performance,
    timeslot = _ref11.timeslot,
    waitingListEnabled = _ref11.waitingListEnabled,
    showPrice = _ref11.showPrice,
    currencyCode = _ref11.currencyCode,
    isMatch = _ref11.isMatch,
    onActionClick = _ref11.onActionClick,
    displayAs = _ref11.displayAs,
    onWatchStreamOnline = _ref11.onWatchStreamOnline,
    ecommerceGoogleTracking = _ref11.ecommerceGoogleTracking,
    productTitle = _ref11.productTitle,
    resaleAvailability = _ref11.resaleAvailability,
    themeQueries = _ref11.themeQueries;
  cov_xmzdhde1r().f[20]++;
  var _ref12 = (cov_xmzdhde1r().s[96]++, (cov_xmzdhde1r().b[36][0]++, performance) || (cov_xmzdhde1r().b[36][1]++, timeslot) || (cov_xmzdhde1r().b[36][2]++, product)),
    action = _ref12.action,
    notOnSales = _ref12.notOnSales,
    restrictedAdv = _ref12.restrictedAdv,
    salesStartDate = _ref12.salesStartDate,
    salesEndDate = _ref12.salesEndDate,
    availability = _ref12.availability;
  var minAmount = (cov_xmzdhde1r().s[97]++, (cov_xmzdhde1r().b[37][0]++, performance) && (cov_xmzdhde1r().b[37][1]++, performance.minAmount) || (cov_xmzdhde1r().b[37][2]++, product) && (cov_xmzdhde1r().b[37][3]++, product.minAmount));
  var isSoldOut = (cov_xmzdhde1r().s[98]++, (cov_xmzdhde1r().b[38][0]++, availability === 'NONE') && (cov_xmzdhde1r().b[38][1]++, !notOnSales));
  var isInFutureSalesPeriod = (cov_xmzdhde1r().s[99]++, (cov_xmzdhde1r().b[39][0]++, notOnSales) && (cov_xmzdhde1r().b[39][1]++, !restrictedAdv));
  var isOutOfSale = (cov_xmzdhde1r().s[100]++, (cov_xmzdhde1r().b[40][0]++, notOnSales) && (cov_xmzdhde1r().b[40][1]++, (0, _utils2.isAfterSaleEnd)(salesEndDate)));
  var isAvailableOnSales = (cov_xmzdhde1r().s[101]++, (cov_xmzdhde1r().b[41][0]++, !isSoldOut) && (cov_xmzdhde1r().b[41][1]++, !notOnSales));
  var isCheckResaleAvailabilityVisible = (cov_xmzdhde1r().s[102]++, (0, _utils2.getResaleAvailabilityVisibility)(isSoldOut, resaleAvailability, product));
  var resaleURL = (cov_xmzdhde1r().s[103]++, (0, _utils2.buildResaleURL)(product, performance, resaleAvailability));
  var buttonVariant = (cov_xmzdhde1r().s[104]++, function () {
    cov_xmzdhde1r().f[21]++;
    cov_xmzdhde1r().s[105]++;
    return _button.ButtonVariant.primary;
  }());
  cov_xmzdhde1r().s[106]++;
  var SoldOutContent = function SoldOutContent() {
    cov_xmzdhde1r().f[22]++;
    cov_xmzdhde1r().s[107]++;
    return /*#__PURE__*/_react.default.createElement(BoxSoldOutContent, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 757,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement(SoldOutLabel, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 758,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.full',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 759,
        columnNumber: 13
      }
    })), (cov_xmzdhde1r().b[42][0]++, waitingListEnabled) && (cov_xmzdhde1r().b[42][1]++, product.waitingListUrl) && (cov_xmzdhde1r().b[42][2]++, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
      buttonVariant: buttonVariant,
      product: product,
      actions: {
        subscribe: product.waitingListUrl
      },
      onActionClick: onActionClick,
      accessibilityActionLabel: productTitle,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 763,
        columnNumber: 15
      }
    })), (cov_xmzdhde1r().b[43][0]++, isCheckResaleAvailabilityVisible) && (cov_xmzdhde1r().b[43][1]++, /*#__PURE__*/_react.default.createElement(_CheckResaleAvailability.default, {
      justifyContentDirection: "flex-start",
      onCheckResaleAvalClickHandler: function onCheckResaleAvalClickHandler() {
        cov_xmzdhde1r().f[23]++;
        cov_xmzdhde1r().s[108]++;
        return window.open(resaleURL, '_blank');
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 772,
        columnNumber: 13
      }
    })));
  };
  cov_xmzdhde1r().s[109]++;
  var ComingSoonContent = function ComingSoonContent() {
    cov_xmzdhde1r().f[24]++;
    cov_xmzdhde1r().s[110]++;
    return /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
      flexDirection: "column",
      column: true,
      py: 1,
      className: "stx-ComingSoonContent",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 781,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement(CenterText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 782,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.comingSoon',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 783,
        columnNumber: 13
      }
    })), (cov_xmzdhde1r().b[44][0]++, salesStartDate) && (cov_xmzdhde1r().b[44][1]++, /*#__PURE__*/_react.default.createElement(SalesStartDate, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 786,
        columnNumber: 13
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
      value: salesStartDate,
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 787,
        columnNumber: 15
      }
    }))));
  };
  cov_xmzdhde1r().s[111]++;
  var OutOfSaleContent = function OutOfSaleContent() {
    cov_xmzdhde1r().f[25]++;
    cov_xmzdhde1r().s[112]++;
    return /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
      column: true,
      py: 1,
      className: "stx-OutOfSale",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 801,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement(CenterText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 802,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.outOfSale',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 803,
        columnNumber: 13
      }
    })));
  };
  cov_xmzdhde1r().s[113]++;
  var ProductLineActionButton = function ProductLineActionButton() {
    cov_xmzdhde1r().f[26]++;
    var shouldShowPrice = (cov_xmzdhde1r().s[114]++, (cov_xmzdhde1r().b[45][0]++, showPrice) && (cov_xmzdhde1r().b[45][1]++, minAmount >= 0));
    var displayAction = (cov_xmzdhde1r().s[115]++, _objectSpread({}, action));
    var buyAction = (cov_xmzdhde1r().s[116]++, displayAction.buy);
    var props = (cov_xmzdhde1r().s[117]++, {
      onActionClick: onActionClick,
      product: product,
      performance: performance,
      ecommerceGoogleTracking: ecommerceGoogleTracking
    });
    var _ref13 = (cov_xmzdhde1r().s[118]++, buildStreamOnlineConfig(product, performance, timeslot, displayAs)),
      shouldDisplayWatchNow = _ref13.shouldDisplayWatchNow,
      productId = _ref13.productId,
      performanceId = _ref13.performanceId,
      timeslotId = _ref13.timeslotId,
      buyActionUrl = _ref13.buyActionUrl,
      accessCode = _ref13.accessCode,
      isAlreadyWatch = _ref13.isAlreadyWatch,
      isLoginRequired = _ref13.isLoginRequired;

    // Show minAmount as label on buy button
    cov_xmzdhde1r().s[119]++;
    if (shouldShowPrice) {
      cov_xmzdhde1r().b[46][0]++;
      cov_xmzdhde1r().s[120]++;
      // Replace by custom label button
      delete displayAction.buy;
    } else {
      cov_xmzdhde1r().b[46][1]++;
    }
    var customMsg = (cov_xmzdhde1r().s[121]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: isMatch ? (cov_xmzdhde1r().b[47][0]++, 'gravity.Product.ticketFrom') : (cov_xmzdhde1r().b[47][1]++, 'gravity.Product.priceFrom'),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 831,
        columnNumber: 11
      }
    }));
    cov_xmzdhde1r().s[122]++;
    if (shouldDisplayWatchNow) {
      cov_xmzdhde1r().b[48][0]++;
      cov_xmzdhde1r().s[123]++;
      return /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
        className: "stx-ProductLineActionButton",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 837,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
        small: themeQueries.EVOLUTION,
        buttonVariant: buttonVariant,
        product: product,
        performance: performance,
        timeslot: timeslot,
        onActionClick: function onActionClick() {
          cov_xmzdhde1r().f[27]++;
          cov_xmzdhde1r().s[124]++;
          return onWatchStreamOnline({
            productId: productId,
            performanceId: performanceId,
            timeslotId: timeslotId
          }, buyActionUrl, isLoginRequired);
        },
        inline: true,
        ecommerceGoogleTracking: ecommerceGoogleTracking,
        actions: isAlreadyWatch ? (cov_xmzdhde1r().b[49][0]++, {
          reWatch: (0, _get.default)(product, 'action.watchNow', '')
        }) : (cov_xmzdhde1r().b[49][1]++, {
          watchNow: (0, _get.default)(product, 'action.watchNow', '')
        }),
        buttonNote: accessCode !== '' ? (cov_xmzdhde1r().b[50][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'streamOnline.label.accessCode',
          values: {
            code: accessCode
          },
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 860,
            columnNumber: 21
          }
        })) : (cov_xmzdhde1r().b[50][1]++, null),
        accessibilityActionLabel: productTitle,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 838,
          columnNumber: 15
        }
      }));
    } else {
      cov_xmzdhde1r().b[48][1]++;
    }
    cov_xmzdhde1r().s[125]++;
    return /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
      className: "stx-ProductLineActionButton",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 872,
        columnNumber: 11
      }
    }, (cov_xmzdhde1r().b[51][0]++, shouldShowPrice) && (cov_xmzdhde1r().b[51][1]++, buyAction) && (cov_xmzdhde1r().b[51][2]++, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
      className: "stx-RightContentButtonWrapper",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 875,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react.default.createElement(RightContentButton, (0, _extends2.default)({
      variant: buttonVariant,
      small: themeQueries.EVOLUTION
    }, _ProductHelper.default.getActionHandler(props, product.id, buyAction), {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 876,
        columnNumber: 19
      }
    }), /*#__PURE__*/_react.default.createElement(_price.default, {
      currencyCode: currencyCode,
      minAmount: minAmount,
      labelFrom: customMsg,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 880,
        columnNumber: 21
      }
    }), /*#__PURE__*/_react.default.createElement(AccessibilityTitleContent, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 885,
        columnNumber: 21
      }
    }, productTitle)))), /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
      buttonVariant: buttonVariant,
      product: product,
      performance: performance,
      timeslot: timeslot,
      actions: displayAction,
      onActionClick: onActionClick,
      ecommerceGoogleTracking: ecommerceGoogleTracking,
      accessibilityActionLabel: productTitle,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 889,
        columnNumber: 13
      }
    }));
  };
  cov_xmzdhde1r().s[126]++;
  return /*#__PURE__*/_react.default.createElement(RightContentWrapper, {
    auto: true,
    direction: 'column',
    p: [0, 0],
    py: (1, 0),
    width: [1, 0.5, 0.2],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 903,
      columnNumber: 9
    }
  }, (cov_xmzdhde1r().b[52][0]++, isOutOfSale) && (cov_xmzdhde1r().b[52][1]++, /*#__PURE__*/_react.default.createElement(OutOfSaleContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 904,
      columnNumber: 27
    }
  })), (cov_xmzdhde1r().b[53][0]++, !isOutOfSale) && (cov_xmzdhde1r().b[53][1]++, isInFutureSalesPeriod) && (cov_xmzdhde1r().b[53][2]++, /*#__PURE__*/_react.default.createElement(ComingSoonContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 905,
      columnNumber: 53
    }
  })), (cov_xmzdhde1r().b[54][0]++, isSoldOut) && (cov_xmzdhde1r().b[54][1]++, /*#__PURE__*/_react.default.createElement(SoldOutContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 906,
      columnNumber: 25
    }
  })), (cov_xmzdhde1r().b[55][0]++, isAvailableOnSales) && (cov_xmzdhde1r().b[55][1]++, /*#__PURE__*/_react.default.createElement(ProductLineActionButton, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 907,
      columnNumber: 34
    }
  })));
})));
cov_xmzdhde1r().s[127]++;
RightContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Need the currency code to display correctly the price  */
  currencyCode: _propTypes.default.string,
  /* Should we display the buttons to access the ts pages (buy, reserve, request, option) */
  waitingListEnabled: _propTypes.default.bool,
  /* Show product price minimum */
  showPrice: _propTypes.default.bool,
  /* Display as match or normal product */
  isMatch: _propTypes.default.bool.isRequired,
  onActionClick: _propTypes.default.func,
  displayAs: _propTypes.default.oneOf(['PRODUCT', 'PERFORMANCE', 'TOUR']),
  /** Function to handle watch stream online */
  onWatchStreamOnline: _propTypes.default.func,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Key to generate unique id for product title */
  keyPrefix: _propTypes.default.string,
  productTitle: _propTypes.default.string,
  resaleAvailability: _propTypes.default.shape({}),
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType
};
cov_xmzdhde1r().s[128]++;
RightContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  showPrice: false,
  waitingListEnabled: false,
  currencyCode: null,
  onActionClick: null,
  displayAs: null,
  onWatchStreamOnline: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  keyPrefix: null,
  productTitle: null,
  resaleAvailability: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};

/*
* Component to display a product in a line
*/
cov_xmzdhde1r().s[129]++;
var ProductLine = function ProductLine(props) {
  cov_xmzdhde1r().f[28]++;
  var _ref14 = (cov_xmzdhde1r().s[130]++, props),
    product = _ref14.product,
    showDescription = _ref14.showDescription,
    performance = _ref14.performance,
    timeslot = _ref14.timeslot,
    isSignedIn = _ref14.isSignedIn,
    intl = _ref14.intl,
    onActionClick = _ref14.onActionClick,
    isLandingPage = _ref14.isLandingPage,
    ecommerceGoogleTracking = _ref14.ecommerceGoogleTracking,
    displayAs = _ref14.displayAs,
    replaceProductNameByPerformance = _ref14.replaceProductNameByPerformance,
    keyPrefix = _ref14.keyPrefix,
    resaleAvailability = _ref14.resaleAvailability,
    themeQueries = _ref14.themeQueries,
    lastItemId = _ref14.lastItemId;
  var _ref15 = (cov_xmzdhde1r().s[131]++, product),
    internetDescriptionUrl = _ref15.internetDescriptionUrl;
  function decodeHtmlString(inputString) {
    cov_xmzdhde1r().f[29]++;
    // convert "Chris&apos;&nbsp;corner" to "Chris' corner"
    var textArea = (cov_xmzdhde1r().s[132]++, document.createElement('textArea'));
    cov_xmzdhde1r().s[133]++;
    textArea.innerHTML = inputString;
    cov_xmzdhde1r().s[134]++;
    return inputString ? (cov_xmzdhde1r().b[56][0]++, textArea.value) : (cov_xmzdhde1r().b[56][1]++, undefined);
  }
  var restrictedAdv = (cov_xmzdhde1r().s[135]++, _ProductHelper.default.getVariableByKey(product, performance, timeslot, null, 'restrictedAdv'));
  var description = (cov_xmzdhde1r().s[136]++, decodeHtmlString(_ProductHelper.default.getVariableByKey(product, performance, timeslot, null, 'description')));
  var isMatch = (cov_xmzdhde1r().s[137]++, Boolean((cov_xmzdhde1r().b[57][0]++, product.productType === 'SPORTING_EVENT') && (cov_xmzdhde1r().b[57][1]++, performance)));
  var titleId = (cov_xmzdhde1r().s[138]++, getAccessibilityTitleId(product, performance, timeslot));
  var accessibilityHeadingTitle = (cov_xmzdhde1r().s[139]++, "".concat(keyPrefix).concat(ACCESSIBILITY_TITLE_PREFIX).concat(titleId));
  var usePerformanceName = (cov_xmzdhde1r().s[140]++, (cov_xmzdhde1r().b[58][0]++, displayAs === 'PERFORMANCE') && (cov_xmzdhde1r().b[58][1]++, replaceProductNameByPerformance));
  var productTitle = (cov_xmzdhde1r().s[141]++, _ProductHelper.default.getProductTitle({
    product: product,
    performance: performance,
    intl: intl,
    usePerformanceName: usePerformanceName
  }));
  var productDescription = (cov_xmzdhde1r().s[142]++, /*#__PURE__*/_react.default.createElement(_ProductDescription.default, {
    ariaControlId: titleId,
    describedById: accessibilityHeadingTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1015,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
    width: 1,
    p: [1, 2],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1016,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: titleId,
    dangerouslySetInnerHTML: {
      __html: description
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1017,
      columnNumber: 9
    }
  }))));
  cov_xmzdhde1r().s[143]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    productId: product.id,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1023,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(AccessibilityHeading, {
    id: accessibilityHeadingTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1024,
      columnNumber: 7
    }
  }, productTitle), /*#__PURE__*/_react.default.createElement(LeftContent, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    isMatch: isMatch,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    isLandingPage: isLandingPage,
    productTitle: productTitle,
    lastItemId: lastItemId,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1025,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(MainContent, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    isMatch: isMatch,
    intl: intl,
    replaceProductNameByPerformance: usePerformanceName,
    productDescription: (cov_xmzdhde1r().b[59][0]++, themeQueries.EVOLUTION) && (cov_xmzdhde1r().b[59][1]++, showDescription) && (cov_xmzdhde1r().b[59][2]++, description) && (cov_xmzdhde1r().b[59][3]++, productDescription),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1035,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(RightContent, (0, _extends2.default)({}, props, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    isMatch: isMatch,
    onActionClick: onActionClick,
    productTitle: productTitle,
    resaleAvailability: resaleAvailability,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1046,
      columnNumber: 7
    }
  })), (cov_xmzdhde1r().b[60][0]++, restrictedAdv) && (cov_xmzdhde1r().b[60][1]++, /*#__PURE__*/_react.default.createElement(RestrictedAdvBox, {
    py: 1,
    width: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1057,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
    column: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1058,
      columnNumber: 11
    }
  }, isSignedIn ? (cov_xmzdhde1r().b[61][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: 'gravity.Product.restrictedOfferMsg',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1060,
      columnNumber: 15
    }
  })) : (cov_xmzdhde1r().b[61][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: 'gravity.Product.restrictedOfferMsgWithoutLogin',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1062,
      columnNumber: 15
    }
  })), (cov_xmzdhde1r().b[62][0]++, internetDescriptionUrl) && (cov_xmzdhde1r().b[62][1]++, /*#__PURE__*/_react.default.createElement(_button.default, {
    small: true,
    flat: true,
    href: internetDescriptionUrl,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1065,
      columnNumber: 15
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.moreInfo",
    defaultMessage: "More info",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1066,
      columnNumber: 17
    }
  })))))), (cov_xmzdhde1r().b[63][0]++, themeQueries.EQUILIBRIUM) && (cov_xmzdhde1r().b[63][1]++, showDescription) && (cov_xmzdhde1r().b[63][2]++, description) && (cov_xmzdhde1r().b[63][3]++, productDescription), /*#__PURE__*/_react.default.createElement(_jsonMetadata.default, {
    jsonMetadata: product.jsonMetadata,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1074,
      columnNumber: 7
    }
  }));
};
cov_xmzdhde1r().s[144]++;
ProductLine.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* Show product description */
  showDescription: _propTypes.default.bool,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /** Type definitions for react-intl, using for dynamic message */
  intl: _reactIntl.intlShape.isRequired,
  /** The function called when clicking on the product or occurence action */
  onActionClick: _propTypes.default.func,
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Key to generate unique id for product title */
  keyPrefix: _propTypes.default.string,
  displayAs: _propTypes.default.oneOf(['PRODUCT', 'PERFORMANCE', 'TOUR']),
  replaceProductNameByPerformance: _propTypes.default.bool,
  resaleAvailability: _propTypes.default.shape({}),
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType,
  lastItemId: _propTypes.default.number
};
cov_xmzdhde1r().s[145]++;
ProductLine.defaultProps = {
  showPrice: false,
  showDescription: false,
  performance: undefined,
  timeslot: undefined,
  isSignedIn: false,
  onActionClick: null,
  isLandingPage: false,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  keyPrefix: null,
  displayAs: null,
  replaceProductNameByPerformance: false,
  resaleAvailability: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  lastItemId: 0
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(ProductLine)));